var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcoPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 9.25 9.25)",
    id: "opQj2mSER2Mli_QxDskSy"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(107,70,236)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(166,166,166)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-9.25, -9.25)",
    d: "M 12.938 13.646 L 13.251 13.958 L 17.293 18.001 L 18 17.294 L 13.957 13.252 L 13.644 12.939 L 13.917 12.59 C 14.942 11.28 15.5 9.664 15.5 8 L 12.938 13.646 Z M 12.938 13.646 L 12.589 13.918 M 12.938 13.646 L 12.589 13.918 M 12.589 13.918 C 11.279 14.943 9.663 15.5 8 15.5 L 12.589 13.918 Z M 8 15.5 C 3.865 15.5 0.5 12.135 0.5 8 C 0.5 3.865 3.865 0.5 8 0.5 C 12.135 0.5 15.5 3.865 15.5 8 L 13.2 12.999 L 8 15.5 Z M 14.5 8 C 14.5 4.415 11.585 1.5 8 1.5 C 4.415 1.5 1.5 4.415 1.5 8 C 1.5 11.585 4.415 14.5 8 14.5 C 11.585 14.5 14.5 11.585 14.5 8 Z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcoPurple);
export default __webpack_public_path__ + "static/media/search-ico_purple.1d05efce3ee6f196179ffbbca60166df.svg";
export { ForwardRef as ReactComponent };